import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <div className="container mb-5">
            {/* Breadcrumb Navigation */}
            <nav aria-label="breadcrumb" className="mt-4 mb-5">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/" className="text-dark text-decoration-none">
                            <i className="fas fa-home me-2"></i> Home
                        </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        <i className="fa-regular fa-folder me-2"></i> Terms & Conditions
                    </li>
                </ol>
            </nav>

            <div>
                <div className="card-body">
                    <h1 className="mb-4">Terms & Conditions</h1>

                    <p>
                        Welcome to Online Shop Matrix! By accessing or using our website and services, you agree to comply with and be bound by the following Terms and Conditions.
                        Please read them carefully.
                    </p>

                    <h3>1. Use of the Website</h3>
                    <ul>
                        <li>You must be at least 18 years old or have reached the age of majority in your jurisdiction to use our website.</li>
                        <li>By using our website, you agree not to engage in any activity that may harm, disrupt, or interfere with the proper functioning of the website or services.</li>
                        <li>You agree not to misuse our services for any unlawful or unauthorized purposes.</li>
                    </ul>

                    <h3>2. Account Registration</h3>
                    <ul>
                        <li>To make a purchase or access certain features, you may be required to create an account.</li>
                        <li>You are responsible for maintaining the confidentiality of your account login information and for all activities conducted through your account.</li>
                        <li>Notify us immediately of any unauthorized use of your account or any other security breach.</li>
                    </ul>

                    <h3>3. Product Information</h3>
                    <ul>
                        <li>We make reasonable efforts to ensure product descriptions, prices, and availability are accurate. However, errors may occur.</li>
                        <li>We reserve the right to correct errors, update information, or cancel orders if necessary.</li>
                    </ul>

                    <h3>4. Orders and Payment</h3>
                    <ul>
                        <li>By placing an order, you are making an offer to purchase products under these terms.</li>
                        <li>All payments must be made through our authorized payment methods.</li>
                        <li>We reserve the right to refuse or cancel orders at our discretion, including orders that violate these terms or contain incorrect information.</li>
                    </ul>

                    <h3>5. Shipping and Delivery</h3>
                    <ul>
                        <li>Shipping times are estimates and may vary depending on location, product availability, and other factors.</li>
                        <li>Online Shop Matrix is not responsible for delays caused by third-party shipping carriers.</li>
                        <li>Customers are responsible for providing accurate delivery information.</li>
                    </ul>

                    <h3>6. Returns and Refunds</h3>
                    <p>
                        Returns, refunds, and exchanges are governed by our <Link to="/return-refund" className="text-decoration-none">Return & Refund Policy</Link>.
                        By placing an order, you agree to abide by the terms outlined in that policy.
                    </p>

                    <h3>7. Intellectual Property</h3>
                    <ul>
                        <li>All content, logos, images, and materials on the website are the property of Online Shop Matrix or its licensors and are protected by copyright and intellectual property laws.</li>
                        <li>You may not copy, reproduce, or distribute any content from the website without prior written consent.</li>
                    </ul>

                    <h3>8. Limitation of Liability</h3>
                    <ul>
                        <li>Online Shop Matrix is not liable for any direct, indirect, incidental, or consequential damages resulting from the use of our website or services.</li>
                        <li>We do not guarantee uninterrupted access or error-free operation of the website.</li>
                    </ul>

                    <h3>9. Governing Law</h3>
                    <p>
                        These Terms and Conditions are governed by the laws of the State of New Mexico, USA. Any disputes arising from the use of our website shall be resolved under the jurisdiction of New Mexico courts.
                    </p>

                    <h3>10. Changes to Terms</h3>
                    <p>
                        We reserve the right to update or modify these Terms and Conditions at any time.
                        Any changes will be posted on this page with an updated effective date. Continued use of the website constitutes acceptance of the revised terms.
                    </p>

                    <h3>11. Contact Us</h3>
                    <p>
                        For questions or concerns regarding these Terms and Conditions, please contact us:<br />
                        Online Shop Matrix<br />
                        2120 Camino Doce SW, Deming, New Mexico 88030, USA<br />
                        Phone: +1 (574) 858-0288<br />
                        Email: contact@onlineshopmatrix.com
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
